import { useSelector } from 'react-redux';
import { createAction, createReducer } from 'redux-act';

import type { IAbTestingInfo } from '@sravni/ab-testing-sdk/lib/node';

import type { IPageMeta } from '@src/@types/pageMeta';
import { SearchSource } from '@src/@types/searchSource';
import type { IGlobalState } from '@src/reducers/index';

type MetadataState = {
  isReviewer: boolean;
  searchSource: SearchSource | null;
  abTestingInfo: IAbTestingInfo | null;
  pageMeta: IPageMeta;
};

const initialState: MetadataState = {
  isReviewer: false,
  searchSource: null,
  abTestingInfo: null,
  pageMeta: {
    isHiddenPskOnCard: false,
    isDisabledCalculator: false,
  },
};

export const setPageMetaData = createAction<IPageMeta>('metadata/setPageMetaData');

export const setReviewer = createAction<boolean>('metadata/setReviewer');
export const setSearchSource = createAction<SearchSource>('metadata/setSearchSource');
export const setAbTestingInfo = createAction<IAbTestingInfo>('metadata/setAbTestinfInfo');

export const metadataReducer = createReducer<MetadataState>({}, initialState)
  .on(setReviewer, (state, payload) => ({
    ...state,
    isReviewer: payload,
  }))
  .on(setSearchSource, (state, payload) => ({
    ...state,
    searchSource: payload,
  }))
  .on(setAbTestingInfo, (state, payload) => ({
    ...state,
    abTestingInfo: payload,
  }))
  .on(setPageMetaData, (state, payload) => ({
    ...state,
    pageMeta: payload,
  }));

export function useIsReviewer() {
  return useSelector((state: IGlobalState) => state.metadata.isReviewer);
}

export function useSearchSource() {
  return useSelector((state: IGlobalState) => state.metadata.searchSource);
}

export function useIsGoogleSearch() {
  return useSelector((state: IGlobalState) => state.metadata.searchSource === SearchSource.Google);
}

export function useIsDisabledCalculator() {
  return useSelector((state: IGlobalState) => state.metadata?.pageMeta?.isDisabledCalculator);
}
